import React, { useState, useEffect } from "react";
import Modal from "antd/es/modal/Modal";
import { Input, Spin, Checkbox, Button, List, Avatar, Image } from "antd";
import placeholderImage from "../images/placeholder.jpg";
import requests from "../utilities/api";
import endpoints from "../constants/endpoints";
import { RiDeleteBin5Line } from "react-icons/ri";

const dynamic_endpoints = {
  catalog: endpoints.get_product_collection,
  product: endpoints.get_products,
  category: endpoints.get_product_category,
  customers: endpoints.get_customers,
};

const BrowseBox = ({ searchfor, conditionTypeIds, setConditionTypeIds }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [browseData, setBrowseData] = useState([]);
  const [fetchingData, setFetchingData] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedItems, setSelectedItems] = useState(conditionTypeIds); // Temporary state for modal selection
  //  const [loading,setLoading]=useSt
  const fetchData = async () => {
    const api = requests();
    try {
      setFetchingData(true);
      const response = await api.get(
        dynamic_endpoints[searchfor] +
          "?for_discount=true" +
          `${search ? "&search=" + search : ""}`
      );
      setBrowseData(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setFetchingData(false);
    }
  };

  const showModal = () => {
    // Initialize selectedItems to include items already in conditionTypeIds
    setSelectedItems([...conditionTypeIds]);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    // Set conditionTypeIds to exactly match selectedItems
    setConditionTypeIds([...selectedItems]);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSearch("");
    setSelectedItems([]); // Reset selection when canceling
  };

  const handleCheckboxChange = (checked, item) => {
    if (checked) {
      setSelectedItems((prev) => [...prev, item]);
    } else {
      setSelectedItems((prev) => prev.filter((i) => i.id !== item.id));
    }
  };

  useEffect(() => {
    fetchData();
  }, [searchfor, search]);

  // Handle the delete action in the List
  const handleDelete = (item) => {
    const updatedItems = conditionTypeIds.filter((i) => i.id !== item.id);
    setConditionTypeIds(updatedItems);
  };

  return (
    <>
      <Input
        value={""}
        onClick={showModal}
        onChange={showModal}
        placeholder={"Search " + searchfor}
      />

      <Modal
        title={`Add ${searchfor}`}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleOk}>
            Add
          </Button>,
        ]}
        // style={{ display: "flex" }}
      >
        <Input
          style={{ marginBottom: "20px" }}
          placeholder={"Search " + searchfor}
          onChange={(e) => setSearch(e.target.value)}
          value={search}
        />

        <Spin spinning={fetchingData}>
          {browseData?.map((item) => (
            <div style={{ marginBottom: "10px" }} key={item.id}>
              <Checkbox
                checked={selectedItems.some((i) => i.id === item.id)}
                onChange={(e) => handleCheckboxChange(e.target.checked, item)}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 20,
                  }}
                >
                  {item.name ? (
                    // <img
                    //   src={
                    //     item.icon?.[0]?.url ||
                    //     item.image?.[0]?.url ||
                    //     placeholderImage
                    //   }
                    //   alt="icon"
                    //   style={{ width: "60px" }}
                    //   className="table-cell-product-image"
                    // />
                    <Image
                      width={40}
                      src={
                        item?.schema
                          ? item.image?.[0]?.url
                          : item.icon?.[0]?.url
                      }
                      fallback="data:image/png;base64,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"
                      preview={false}
                      className="table-cell-product-image"
                    />
                  ) : null}
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontWeight: 500, fontSize: "15px" }}>
                      {item.name || item.email}
                    </span>
                    {item.sku && (
                      <span style={{ fontWeight: 500, fontSize: "12px" }}>
                        SKU: {item.sku}
                      </span>
                    )}
                  </div>
                </div>
              </Checkbox>
            </div>
          ))}
        </Spin>
      </Modal>

      {/* List to display selected conditionTypeIds after clicking Add */}
      {conditionTypeIds.length > 0 ? (
        <Spin spinning={fetchingData}>
          <List
            itemLayout="horizontal"
            dataSource={conditionTypeIds}
            renderItem={(item) => (
              <List.Item
                actions={[
                  <button
                    key="delete"
                    type="button"
                    style={{
                      border: "none",
                      background: "none",
                      color: "red",
                      cursor: "pointer",
                    }}
                    onClick={() => handleDelete(item)}
                  >
                    <RiDeleteBin5Line />
                  </button>,
                ]}
              >
                <List.Item.Meta
                  avatar={
                    <Avatar
                      src={
                        item.icon?.[0]?.url ||
                        item.image?.[0]?.url ||
                        placeholderImage
                      }
                    />
                  }
                  title={item.name || item.customer_name}
                  description={item?.sku && `SKU:${item?.sku}`}
                />
              </List.Item>
            )}
          />
        </Spin>
      ) : null}
    </>
  );
};

export default BrowseBox;
